var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.429204 0.69198C0.691283 0.467341 1.08585 0.497692 1.31048 0.759771L6.31048 6.5931C6.5111 6.82716 6.5111 7.17254 6.31048 7.40659L1.31048 13.2399C1.08585 13.502 0.691283 13.5324 0.429204 13.3077C0.167126 13.0831 0.136775 12.6885 0.361414 12.4264L5.01278 6.99985L0.361414 1.57326C0.136775 1.31118 0.167126 0.916619 0.429204 0.69198ZM3.7627 0.692067C4.02478 0.467428 4.41934 0.497779 4.64398 0.759857L9.64398 6.59319C9.8446 6.82725 9.8446 7.17262 9.64398 7.40668L4.64398 13.24C4.41934 13.5021 4.02478 13.5324 3.7627 13.3078C3.50062 13.0832 3.47027 12.6886 3.69491 12.4265L8.34627 6.99993L3.69491 1.57335C3.47027 1.31127 3.50062 0.916705 3.7627 0.692067Z",
    fill: "#0D0B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.a3f52220dece3f42cb6f1d3e526eef0e.svg";
export { ForwardRef as ReactComponent };